export default __webpack_public_path__ + "static/media/atletico.ae40ff18.jpg";